import React from 'react'
import { TabMenu } from 'primereact/tabmenu'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

export default function MenuHardware ({ setComponentsModal }) {
  const { t } = useTranslation('hardware')

  const items = [
    { label: t('menu1'), command: () => { setComponentsModal({ physicalMemory: false, diskDrive: false, bios: false, processor: true }) } },
    { label: t('menu2'), command: () => { setComponentsModal({ physicalMemory: false, diskDrive: true, bios: false, processor: false }) } },
    { label: t('menu3'), command: () => { setComponentsModal({ physicalMemory: true, diskDrive: false, bios: false, processor: false }) } },
    { label: t('menu4'), command: () => { setComponentsModal({ physicalMemory: false, diskDrive: false, bios: true, processor: false }) } }
  ]

  return (<TabMenu model={items} />)
}

MenuHardware.propTypes = {
  setComponentsModal: PropTypes.func
}
